module.exports = __webpack_public_path__ + "fonts/1182328.eot";